import { render, staticRenderFns } from "./ProcessTypeEditor.vue?vue&type=template&id=55293be6&scoped=true&"
import script from "./ProcessTypeEditor.vue?vue&type=script&lang=js&"
export * from "./ProcessTypeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTypeEditor.vue?vue&type=style&index=0&id=55293be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55293be6",
  null
  
)

export default component.exports